<template>

	<div>
		<div class="btns-top">
			<a class="btn btn-add fa fa-plus transition-fadeinup"></a>
			<a href="pages/showpad-config-sidebar.php" data-routing-target="#sidebar" class="btn btn-add fa fa-clipboard-check transition-fadeinup transition-delay-01"></a>
		</div>

		<ul class="nested-sortable main-sortable">
			<!-- legend -->
			<li class="legend">
				<div class="item">
					<div class="left">
						<div>Readable-name</div>
					</div>

					<div class="right">
						<div>Object</div>
						<div>Type</div>
						<div># records</div>
					</div>
				</div>
			</li>

			<li>
				<div class="item">
					<div class="left">
						<div class="handle">
							<div class="grip"></div>
						</div>
						<div>
							<a class="btn-toggle-child"><i class="fa fa-plus"></i></a> <input type="text" value="Header">
						</div>
					</div>

					<div class="right">
						<div>
							<div class="description">group</div>
						</div>
						<div></div>
						<div></div>
					</div>
				</div>

				<ul class="nested-sortable">
					<li>
						<div class="item">
							<div class="left">
								<div class="handle">
									<div class="grip"></div>
								</div>
								<div>
									<input type="text" value="value">
								</div>
							</div>

							<div class="right">
								<div>
									Roche key messages
								</div>
								<div>
									Asset
								</div>
								<div>3</div>
							</div>
						</div>

						<ul class="nested-sortable"></ul>
					</li>

					<li>
						<div class="item">
							<div class="left">
								<div class="handle">
									<div class="grip"></div>
								</div>
								<div>
									<a class="btn-toggle-child"><i class="fa fa-plus"></i></a> <input type="text" value="value">
								</div>
							</div>

							<div class="right">
								<div>
									Tree blutbank branches
								</div>
								<div>
									Asset
								</div>
								<div>3000</div>
							</div>
						</div>

						<ul class="nested-sortable">
							<li>
								<div class="item">
									<div class="left">
										<div class="handle">
											<div class="grip"></div>
										</div>
										<div>
											<a class="btn-toggle-child"><i class="fa fa-plus"></i></a> <input type="text" value="value">
										</div>
									</div>

									<div class="right">
										<div>
											Testportfolio
										</div>
										<div>
											Asset / Tag
										</div>
										<div>3</div>
									</div>
								</div>

								<ul class="nested-sortable">
									<li>
										<div class="item">
											<div class="left">
												<div class="handle">
													<div class="grip"></div>
												</div>
												<div>
													<input type="text" value="value">
												</div>
											</div>

											<div class="right">
												<div>
													Roche key messages
												</div>
												<div>
													Asset
												</div>
												<div>3</div>
											</div>
										</div>

										<ul class="nested-sortable"></ul>
									</li>
								</ul>
							</li>

							<li>
								<div class="item">
									<div class="left">
										<div class="handle">
											<div class="grip"></div>
										</div>
										<div>
											<input type="text" value="value">
										</div>
									</div>

									<div class="right">
										<div>
											Roche key messages
										</div>
										<div>
											Asset
										</div>
										<div>3</div>
									</div>
								</div>

								<ul class="nested-sortable"></ul>
							</li>
						</ul>
					</li>
				</ul>
			</li>

			<li>
				<div class="item">
					<div class="left">
						<div class="handle">
							<div class="grip"></div>
						</div>
						<div>
							<a class="btn-toggle-child"><i class="fa fa-plus"></i></a> <input type="text" value="Trees">
						</div>
					</div>

					<div class="right">
						<div>
							<div class="description">group</div>
						</div>
						<div></div>
						<div></div>
					</div>
				</div>

				<ul class="nested-sortable">
					<li>
						<div class="item">
							<div class="left">
								<div class="handle">
									<div class="grip"></div>
								</div>
								<div>
									<input type="text" value="value">
								</div>
							</div>

							<div class="right">
								<div>
									Roche key messages
								</div>
								<div>
									Asset
								</div>
								<div>3</div>
							</div>
						</div>

						<ul class="nested-sortable"></ul>
					</li>
					<li>
						<div class="item">
							<div class="left">
								<div class="handle">
									<div class="grip"></div>
								</div>
								<div>
									<a class="btn-toggle-child"><i class="fa fa-plus"></i></a> <input type="text" value="value">
								</div>
							</div>

							<div class="right">
								<div>
									Roche key messages
								</div>
								<div>
									Asset
								</div>
								<div>3</div>
							</div>
						</div>

						<ul class="nested-sortable">
							<li>
								<div class="item">
									<div class="left">
										<div class="handle">
											<div class="grip"></div>
										</div>
										<div>
											<input type="text" value="value">
										</div>
									</div>

									<div class="right">
										<div>
											Roche key messages
										</div>
										<div>
											Asset
										</div>
										<div>3</div>
									</div>
								</div>

								<ul class="nested-sortable"></ul>
							</li>
						</ul>
					</li>
				</ul>
			</li>

			<li>
				<div class="item">
					<div class="left">
						<div class="handle">
							<div class="grip"></div>
						</div>
						<div>
							<a class="btn-toggle-child"><i class="fa fa-plus"></i></a> <input type="text" value="Machines">
						</div>
					</div>

					<div class="right">
						<div>
							<div class="description">group</div>
						</div>
						<div></div>
						<div></div>
						<div></div>
					</div>
				</div>

				<ul class="nested-sortable">
					<li>
						<div class="item">
							<div class="left">
								<div class="handle">
									<div class="grip"></div>
								</div>
								<div>
									<input type="text" value="value">
								</div>
							</div>

							<div class="right">
								<div>
									Roche key messages
								</div>
								<div>
									Asset
								</div>
								<div>3</div>
							</div>
						</div>

						<ul class="nested-sortable"></ul>
					</li>
				</ul>
			</li>

		</ul>
	</div>

</template>

<script>

export default {
	name: 'config'
}

</script>
